export const BaseUrl = process.env.REACT_APP_LOCAL_MODE